// SendGrid templates still use snake_case placeholders ({{contact_name}}).
// The API accepts the camelCase dynamic-template-data shape and converts it to
// snake_case before forwarding to SendGrid, so request bodies must stay camelCase.
// The local Handlebars preview renders against the template HTML directly and
// therefore needs the snake_case keys.
//
// Mapped explicitly rather than with a generic camel-to-snake converter, which
// would turn `additionalInfo1` into `additional_info1` and miss the template's
// `additional_info_1`.
const TEMPLATE_PLACEHOLDER_KEYS: Record<string, string> = {
  contactName: 'contact_name',
  deviceName: 'device_name',
  additionalInfoPre: 'additional_info_pre',
  additionalInfo1: 'additional_info_1',
  alertTier: 'alert_tier',
  litersHour: 'liters_hour',
  noHours: 'no_hours',
}

export const toTemplatePlaceholders = (
  data: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      TEMPLATE_PLACEHOLDER_KEYS[key] ?? key,
      value,
    ]),
  )
